import React, { useState } from 'react'
import _, { isEmpty } from 'lodash'
import { Button, Col, Form, Icon, Input, Modal, Select, Row, Upload, Radio, Tooltip } from 'antd'
import { ButtonEx } from '../../../../../../styles/button.style'
import { useDeepEffect } from '../../../../../../utils/hooks'

const LocationForm = (props) => {
  const { visible, onOk, onCancel, formData, form, heroId } = props
  const { getFieldDecorator, validateFields, setFieldsValue } = form

  useDeepEffect(() => {
    if (!isEmpty(formData)) {
      setFieldsValue({
        name: formData.name,
        address: formData.address,
        lat: formData.lat,
        lng: formData.lng
      })
    }
    return () => {
      form.resetFields()
    }
  }, [formData])


  function onSubmit(e) {
    e.preventDefault()
    validateFields(async (err, values) => {
      if (!err) {
        const data = {
          name: values.name,
          address: values.address,
          lat: values.lat,
          lng: values.lng,
          heroId: heroId
        }
        if (!_.isEmpty(formData)) {
          data.id = formData.locationId
        }
        onOk(data)
      }
    })
  }

  return (
    <Modal
      title={`${!_.isEmpty(formData) ? 'Edit' : 'Create'} a Location`}
      visible={visible}
      footer={null}
      onCancel={onCancel}>
      <Form form={form} onSubmit={onSubmit} layout="vertical">
        <Form.Item label="ชื่อสถานที่">
          {getFieldDecorator(`name`, {
          })(<Input.TextArea
            name="name"
            placeholder="รายละเอียด" />)}
        </Form.Item>
        <Form.Item label="ที่อยู่">
          {getFieldDecorator(`address`, {
          })(<Input.TextArea
            name="address"
            placeholder="รายละเอียด" />)}
        </Form.Item>
        <Form.Item label="Latitude">
          {getFieldDecorator(`lat`, {
            rules: [
              {
                required: true,
                message: 'กรุณากรอก'
              }
            ]
          })(<Input type="number"
            name="latitude"
            placeholder="Latitude" />)}
        </Form.Item>
        <Form.Item label="Longitude">
          {getFieldDecorator(`lng`, {
            rules: [
              {
                required: true,
                message: 'กรุณากรอก'
              }
            ]
          })(<Input type="number"
            name="longitude"
            placeholder="Longitude" />)}
        </Form.Item>
        <Row type="flex" gutter={8} justify="end">
          <Col>
            <Button onClick={() => onCancel()}>ยกเลิก</Button>
          </Col>
          <Col>
            <ButtonEx color="#6ebf4b" type="primary" htmlType="submit">
              บันทึก
            </ButtonEx>
          </Col>
        </Row>
      </Form>
    </Modal>
  )
}

const WrappedLocationForm = Form.create({ name: 'LocationForm' })(
  LocationForm
)
export default WrappedLocationForm
